import { _t } from '@bark/bark-core';

export function DashboardEmailTemplates() {
	class DashboardEmailTemplates {
		constructor() {
			this.templates = [];
			this.currentProjectId = null;
			this.buyerName = null;
		}

		init = () => {
			this.getAllTemplates((data) => {
				const { data: templates } = data;
				this.templates = templates;

				this.buildTemplateSelectModal(templates);
			}, function (e) {
				console.log('fail');
				console.log(e);
			});

			this.bindListeners();
			this.bindBractModalListeners();
			this.bindWindowListners();

			this.getSellerData();
		};

		on = (ev, callback) => {
			if (Array.isArray(ev)) {
				ev.forEach((e) => {
					this.on(e, callback);
				});
			} else {
				this._callbacks || (this._callbacks = {});
				(this._callbacks[ev] || (this._callbacks[ev] = [])).push(callback);
			}
		};

		fireEvent = function (event) {
			if (typeof window.verboseEv !== 'undefined' && window.verboseEv === true) {
				console.log(event + ' happened');
			}

			let list, i, l;
			if (!this._callbacks) return;
			if (!(list = this._callbacks[event])) return;

			for (i = 0, l = list.length; i < l; i++) list[i].apply(event);
		};

		setProjectData = (projectId, buyerName) => {
			this.currentProjectId = projectId;
			this.buyerName = buyerName;
		};

		getSellerData = () => {
			const { Bark: { api } = {}, sessionStorage } = window;

			api(
				'seller/self?origin=' + (Bark.isMobile() ? 'mobileweb' : 'desktop'),
				{},
				(response) => {
					let { data } = response;
					let { seller_name, company, telephone, links } = data;

					let name = seller_name || '';
					let companyName = company || '';
					let phone = telephone || '';
					let website = links && links.website ? links.website : '';

					//we are going to use this data around the place, so let's set it into session storage each time we
					// get the info.
					sessionStorage.user = JSON.stringify({
						name,
						companyName,
						phone,
						website,
					});
				},
			);
		};

		apiErrorCallback = (error) => {
			let message = 'Email templates javascript error.'
			if (error && error.message) {
				message += " - " + error.message
			}

			bugsnagClient.notify(new Error(message), {
				metaData: error,
			});
		};

		handleSendEmailClick = () => {
			this.getAllTemplates((data) => {
				let { status, data: templates } = data;

				if (status === true && templates.length === 0) {
					this.loadDefaultResponseTemplate();
					return;
				}

				let buyerName = this.getBuyerName();
				this.openTemplateSelectModal(buyerName);
				templates = [{ title: _t("seller_dashboard-email:new-email-title"), id: 0 }, ...templates];
				this.createTemplatesDropdownInModal(templates);
			}, this.apiErrorCallback);
		};

		getBuyerName = () => this.buyerName;

		buildTemplateSelectModal = (templates) => {
			let modal = Handlebars.compile(
				document.getElementById('select-template-modal').innerHTML,
			);

			let fullModal = modal({
				templates: templates,
				subheader_text: _t('seller_responses:select-response-template.subheader', {
					buyer_public_name: `<span class="buyer-name"></span>`,
					interpolation: { escapeValue: false },
				}),
			});

			let elem = document.createElement('div');
			elem.innerHTML = fullModal;

			document.body.appendChild(elem);
			this.bindTemplateModalListeners();
		};

		addTipsLink = () => {
			$('.tips').removeClass('d-none').addClass('d-flex');
		};

		createTemplatesDropdownInModal = (templates, selectBlank) => {
			const templateSelect = document.getElementById('template-select-dropdown');
			const BractHeaderColumn = document.getElementById('bh-right-column');
			const dropDown = Handlebars.compile(
				document.getElementById('choose-template-dropdown').innerHTML,
			);

			if (!BractHeaderColumn) return;

			templateSelect && templateSelect.remove();

			// There is only the template we pushed into the array. The blank template
			if (templates.length <= 1) {
				this.addTipsLink();
				return;
			}

			BractHeaderColumn.innerHTML = dropDown({
				templates: templates,
			});

			if (selectBlank) {
				$('#template-select-dropdown').val(0);
			}
		};

		handleSendCustomEmailClick = () => {
			this.getAllTemplates((data) => {
				let { data: templates } = data;
				templates = [{ title: _t("seller_dashboard-email:new-email-title"), id: 0 }, ...templates];
				this.createTemplatesDropdownInModal(templates, true);
				this.loadDefaultResponseTemplate();
			}, this.apiErrorCallback);
		};

		/**
		 * This function will either load one of our predefined templates, or if you pass it showNewEmail=true
		 * it will load the most minimal version with just the greeting and their signature, basically a blank email.
		 * @param showNewEmail
		 */
		loadDefaultResponseTemplate = (showNewEmail) => {
			let { Bract, sessionStorage } = window;

			try {
				let seller = JSON.parse(sessionStorage.getItem('user'));
				let templateData = { ...seller, customerName: this.getBuyerName() };
				if (showNewEmail) {
					Bract.loadNewEmail(templateData);
				} else {
					Bract.loadSellerDefaultCreate(templateData);
				}
			} catch (e) {
				Bract.loadBlank();
				bugsnagClient.notify(e);
			}

			$('#bract-modal').modal('show');
		};

		openTemplateSelectModal = (buyerName) => {
			const $selectTemplateModal = $('#selectTemplateModal');
			this.selectFirstTemplate();
			this.showSendTemplateButtonInModal($selectTemplateModal);
			$selectTemplateModal.modal('show');
			$selectTemplateModal.find('span.buyer-name').text(buyerName);

			//we are sneakily pre loading the Bract component so that it won't take long to mount when they eventually need it.
			window.Bract && window.Bract.loadBlank();
		};

		selectFirstTemplate = () => {
			this.selectTemplate($('.email-template-row').first());
		};

		selectTemplate = (row) => {
			$('.email-template-row').removeClass('selected border-primary bg-grey-25');
			row.addClass('selected border-primary bg-grey-25');

			$('#template-select-dropdown').val(row.data('id'));
		};

		handleSelectTemplate = (event) => {
			event.preventDefault();
			this.selectTemplate($(event.currentTarget));
		};

		handleEditTemplate = (event) => {
			event.preventDefault();
			let { Bract } = window;
			let selectedTemplate = document.querySelector('.email-template-row.selected');

			if (selectedTemplate.length !== null && Bract) {
				let { id } = selectedTemplate.dataset;

				if (id > 0) {
					$('#template-select-dropdown').val(id);
					//This looks super weird, but basically we have to load it twice to make sure there are no
					// changes carried over because the iframe only saves on losing focus.
					Bract.loadAllWhite();
					Bract.loadTemplateByIdWithCustomerName(id, this.getBuyerName());
					$('#bract-modal').modal('show');
				}
			}
		};

		getSelectedTemplateId = () => {
			const selectedTemplate = document.querySelector('.email-template-row.selected');

			return selectedTemplate ? selectedTemplate.dataset.id : null;
		};

		handleSendTemplate = (event) => {
			const button = event.currentTarget;
			button.disabled = true;

			let {
				Bark: { api },
				Bract,
			} = window;

			this.currentProjectId &&
				Bract.getHtml((html) => {
					api(
						`seller/response/${this.currentProjectId}/email/`,
						{
							html,
						},
						() => {
							this.emailSuccessCallback(button);
						},
						(error) => {
							button.disabled = false;
							bugsnagClient.notify(new Error('Failed to send a template'), {
								metaData: error,
							});
						},
						'POST',
						Bark.apiVersionHeader('v2'),
					);
				});
		};

		handleTemplateSelectChange = (event) => {
			let id = event.currentTarget.value;
			const { Bract } = window;

			if (id === '0') {
				this.loadDefaultResponseTemplate(true);
			} else {
				Bract.loadAllWhite();
				Bract.loadTemplateByIdWithCustomerName(id, this.getBuyerName());
			}
		};

		handleSendTemplateById = (event) => {
			const button = event.currentTarget;
			button.disabled = true;
			event.preventDefault();
			const {
				Bark: { api },
				Bract,
			} = window;
			let templateId = this.getSelectedTemplateId();

			if (!templateId) {
				this.showErrorInModal('selectTemplateModal', _t("seller_dashboard-email:please-select-template"));
				button.disabled = false;
				return;
			}

			api(
				`seller/response/${this.currentProjectId}/template/${templateId}`,
				{},
				() => {
					this.emailSuccessCallback(button);
				},
				(error) => {
					button.disabled = false;
					this.showErrorInModal(
						'selectTemplateModal',
                        _t("seller_dashboard-email:send-template-error-message"),
					);
					bugsnagClient.notify(new Error('Failed to send a template by id'), {
						metaData: error,
					});
				},
				'POST',
				Bark.apiVersionHeader('v2'),
			);
		};

		showErrorInModal = (modalId, errorText) => {
			$('#' + modalId + ' .error-box .error').text(errorText);
			$('#' + modalId + ' .error-box').removeClass('d-none');
		};

		emailSuccessCallback = (sendButton) => {
			this.fireEvent('success');
			let sendTemplateEvent = new CustomEvent('email-template-sent');
			document.dispatchEvent(sendTemplateEvent);
			$('.modal').modal('hide');
			$('.error-box').addClass('d-none');
			sendButton.disabled = false;
		};

		getAllTemplates = (successCallback, failCallback) => {
			if (window.Bark) {
				return window.Bark.emailService(
					'user/templates/',
					{},
					(data) => successCallback(data),
					(error) => failCallback(error),
					'GET',
				);
			}
		};

		hideSendTemplateButtonInModal = ($modal) => {
			$modal
				.find('.js-edit-template')
				.removeClass('btn-link')
				.addClass('btn-primary large-btn')
				.text('Select');
			$modal.find('.js-send-template-by-id').addClass('d-none');
		};

		showSendTemplateButtonInModal = ($modal) => {
			$modal
				.find('.js-edit-template')
				.removeClass('btn-primary large-btn')
				.addClass('btn-link')
				.text(_t("seller_dashboard-email:preview-edit-button"));
			$modal.find('.js-send-template-by-id').removeClass('d-none');
		};

		selectTemplateOnMobile = () => {
			const bractModal = $('#bract-modal');
			const templateSelectModal = $('#selectTemplateModal');
			let backdrop = document.createElement('div');
			backdrop.classList.add('modal-backdrop', 'show', 'second-backdrop');
			templateSelectModal.find('span.buyer-name').text(this.getBuyerName());

			this.hideSendTemplateButtonInModal(templateSelectModal);

			templateSelectModal.modal('show');

			if (bractModal.hasClass('show')) {
				let bractModalZIndex = bractModal.css('z-index');

				let adjustedBackdropZIndex = parseInt(bractModalZIndex) + 1;
				let adjustedTemplateModalZIndex = parseInt(bractModalZIndex) + 2;

				templateSelectModal.css({ 'z-index': adjustedTemplateModalZIndex });
				backdrop.style.zIndex = adjustedBackdropZIndex;
				document.body.append(backdrop);
			}
		};

		addBackDrop = (firstModalId, secondModalId) => {
			const $firstModal = $('#' + firstModalId);
			const $secondModal = $('#' + secondModalId);

			let backdrop = document.createElement('div');
			backdrop.classList.add('modal-backdrop', 'show', 'second-backdrop');

			let firstModalZIndex = $firstModal.css('z-index');
			let adjustedBackdropZIndex = parseInt(firstModalZIndex) + 1;
			let adjustedSecondModalZIndex = parseInt(firstModalZIndex) + 2;

			$secondModal.css({ 'z-index': adjustedSecondModalZIndex });
			backdrop.style.zIndex = +adjustedBackdropZIndex;
			document.body.append(backdrop);
		};

		closeBractModal = () => {
			modalManager.quickModal(
				'',
				'',
				'<h4 class="text-center mb-0">'+_t("seller_dashboard-email:confirm-close-modal-message")+'</h4>',
				[modalManager.cancelLinkHTML(), modalManager.submitButtonHTML(_t("seller_dashboard-email:continue-button"))],
				['modal-sm'],
				'bract-confirm-close-modal',
			);

			this.addBackDrop('bract-modal', 'bract-confirm-close-modal');
			this.removeBackDropOnClose('bract-confirm-close-modal');
		};

		removeBackDropOnClose = (modalId) => {
			$('#' + modalId).on('hide.bs.modal', () => {
				$('.modal-backdrop.second-backdrop').remove();
			});
		};

		bindBractModalListeners = () => {
			$('.js-confirm-send-email')
				.off('click touch')
				.on('click touch', this.handleSendTemplate);
			$('.js-close-bract').off('click touch').on('click touch', this.closeBractModal);

			$('#bract-modal').on('hidden.bs.modal', (e) => {
				const { Bract } = window;
				Bract && Bract.loadBlank();
			});

			$('#bract-modal').on('shown.bs.modal', (e) => {
				this.makeBractModalFullScreen();
			});

			$(document).on('click', '#bract-confirm-close-modal .modal-submit', () => {
				$('.modal').modal('hide');
			});
		};

		bindTemplateModalListeners = () => {
			$(document).on('click touch', '.email-template-row', (event) =>
				this.handleSelectTemplate(event),
			);

			$('.js-edit-template')
				.off('click touch')
				.on('click touch', this.handleEditTemplate);
			$('.js-send-template-by-id')
				.off('click touch')
				.on('click touch', this.handleSendTemplateById);

			this.removeBackDropOnClose('selectTemplateModal');
		};

		bindListeners = () => {
			$(document).on('click touch', '#btn-send-template', this.handleSendEmailClick);
			$(document).on(
				'click touch',
				'#btn-send-custom-template',
				this.handleSendCustomEmailClick,
			);
			$(document).on(
				'click touch',
				'.js-mobile-choose-template',
				this.selectTemplateOnMobile,
			);
			$(document).on(
				'change',
				'#template-select-dropdown',
				this.handleTemplateSelectChange,
			);
		};

		bindWindowListners = () => {
			window.onresize = this.makeBractModalFullScreen;
		};

		makeBractModalFullScreen = () => {
			const headerHeight = $('.bract-modal .modal-header').outerHeight();
			const footerHeight = $('.bract-modal .modal-footer').outerHeight();

			try {
				const wrapperHeights = headerHeight + footerHeight;
				const viewHeight = window.innerHeight;
				const editorHeight = viewHeight - wrapperHeights;

				$('#inline-editor').css({ height: editorHeight });
			} catch (e) {}
		};
	}

	window.Bark.DashboardEmailTemplates = DashboardEmailTemplates;
}
